import { render } from "./BookingDetailPage.vue?vue&type=template&id=465f7126"
import script from "./BookingDetailPage.vue?vue&type=script&lang=ts"
export * from "./BookingDetailPage.vue?vue&type=script&lang=ts"
script.render = render

export default script